// Configuration
import {configureStore } from '@reduxjs/toolkit';

// Slices
import boardSlice from './boardSlice';
import columnReducer from './columnSlice';

const store = configureStore({
  reducer: {
    // Adicione os reducers dos slices aqui
    board: boardSlice,
    column: columnReducer
  },
});

export default store;